
import React from "react";

export function TruckFormatter(cellContent,row){

    return(
        <>
            <span className="text-dark-75 font-weight-bolder d-block text-center font-size-lg">
                {row.truck[0].name}
            </span>
        </>
    )
}